import LevendeStillbilde from '@nrk/dh-basis-levende-stillbilde'
const VIEWPORT_POSITION_ATTR = 'data-viewport-position'

declare global {
  interface HTMLElement {
    connectedCallback(): void
    disconnectedCallback(): void
  }
}

export class SALevendeStillbilde extends LevendeStillbilde {
  #observer
  connectedCallback() {
    super.connectedCallback()
    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const player: HTMLElement = this as any
          const elementViewportPosition = player.getAttribute(VIEWPORT_POSITION_ATTR)
          if (entry.isIntersecting && elementViewportPosition === 'OUT-OF-VIEWPORT') {
            player.setAttribute(VIEWPORT_POSITION_ATTR, 'IN-VIEWPORT')
          }
          if (!entry.isIntersecting && elementViewportPosition === 'IN-VIEWPORT') {
            player.setAttribute(VIEWPORT_POSITION_ATTR, 'OUT-OF-VIEWPORT')
          }
        }
      },
      {
        threshold: 0.5,
      },
    )
    this.#observer.observe(this)
  }

  disconnectedCallback() {
    this.#observer.disconnect()
    super.disconnectedCallback()
  }
}
